export const breakpoints = { // breakpoints
	lg: 1024, // 1024px
	md: 811, // 811px
	sm: 570, // 570px
	xs: 400, // 400px
};
